export default __webpack_public_path__ + "static/media/walmart.a416f842.jpeg";